import { render, staticRenderFns } from "./wangEnduit.vue?vue&type=template&id=6246fbf2"
import script from "./wangEnduit.vue?vue&type=script&lang=js"
export * from "./wangEnduit.vue?vue&type=script&lang=js"
import style0 from "./wangEnduit.vue?vue&type=style&index=0&id=6246fbf2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports